import { getGradientColor } from './colorUtils';

export function extractStopActivities(
  mapData,
  selectedTour,
  selectedStopIndex,
  showOnlyFirstVisits,
) {
  if (!mapData || !mapData.geo || !mapData.geo.features) {
    return { activities: [], stopLocation: null };
  }

  const stopActivities = [];
  let stopLocation = null;

  mapData.geo.features.forEach((feature) => {
    if (
      feature.geometry.type === 'Point' &&
      feature.properties.stopLocation &&
      feature.properties.types &&
      feature.properties.routeId === selectedTour &&
      feature.properties.stopIndex === selectedStopIndex
    ) {
      if (!stopLocation) {
        const loc = feature.properties.stopLocation;
        stopLocation = [loc.lng, loc.lat];
      }
      if (showOnlyFirstVisits && !feature.properties.isFirstVisit) {
        return;
      }

      stopActivities.push({
        coordinates: feature.geometry.coordinates,
        activityIndex: feature.properties.activityIndex ?? 0,
        activityOrder: feature.properties.activityOrder ?? 0,
      });
    }
  });

  return { activities: stopActivities, stopLocation };
}

export function toLeafletCoordinates(coordinates) {
  return [coordinates[1], coordinates[0]];
}

export function createActivityLines(activities, selectedTour, selectedStopIndex, stopLocation) {
  if (activities.length < 2) {
    return [];
  }

  const lines = [];
  const totalLegs = stopLocation
    ? activities.length + 1
    : activities.length;

  if (stopLocation) {
    lines.push({
      key: `stop-${selectedTour}-${selectedStopIndex}-activity-start`,
      positions: [toLeafletCoordinates(stopLocation), toLeafletCoordinates(activities[0].coordinates)],
      color: getGradientColor(0),
    });
  }

  for (let i = 0; i < activities.length - 1; i++) {
    const start = activities[i];
    const end = activities[i + 1];

    const legIndex = stopLocation ? i + 1 : i;
    const progress = totalLegs > 2 ? legIndex / (totalLegs - 2) : 0;
    const color = getGradientColor(Math.min(progress, 1));

    lines.push({
      key: `stop-${selectedTour}-${selectedStopIndex}-activity-${i}`,
      positions: [toLeafletCoordinates(start.coordinates), toLeafletCoordinates(end.coordinates)],
      color,
    });
  }

  const last = activities[activities.length - 1];
  const returnTarget = stopLocation || activities[0].coordinates;

  lines.push({
    key: `stop-${selectedTour}-${selectedStopIndex}-activity-close`,
    positions: [toLeafletCoordinates(last.coordinates), toLeafletCoordinates(returnTarget)],
    color: getGradientColor(1),
  });

  return lines;
}

export function calculateActivityLines(
  mapData,
  selectedTour,
  selectedStopIndex,
  showOnlyFirstVisits,
) {
  const { activities, stopLocation } = extractStopActivities(
    mapData,
    selectedTour,
    selectedStopIndex,
    showOnlyFirstVisits,
  );

  if (activities.length < 2) {
    return [];
  }

  activities.sort((a, b) => a.activityIndex - b.activityIndex);

  return createActivityLines(activities, selectedTour, selectedStopIndex, stopLocation);
}
